const cotizadorKey = 'lab51_cotizador';

const cotizador = document.querySelector('[data-cotizador]');
const overlay = cotizador?.querySelector('[data-cotizador-overlay]');
const drawer = cotizador?.querySelector('[data-cotizador-drawer]');
const itemsList = cotizador?.querySelector('[data-cotizador-items]');
const subtotal = cotizador?.querySelector('[data-cotizador-subtotal]');
const popup = cotizador?.querySelector('[data-cotizador-popup]');
const popupForm = cotizador?.querySelector('.cotizador-popup__form');
const messageInput = cotizador?.querySelector('[data-cotizador-message]');
const submitSuccess = cotizador?.querySelector('[data-cotizador-submit-success]');
const translationsJson = cotizador?.querySelector('[data-cotizador-translations]');
const locale = cotizador?.dataset.locale || document.documentElement.lang || 'en';
const currency = cotizador?.dataset.currency || 'USD';

let translations = {};
try {
  translations = JSON.parse(translationsJson?.textContent || '{}');
} catch (error) {
  translations = {};
}

function translate(key) {
  return typeof translations[key] === 'string' ? translations[key] : '';
}

function setCotizacion(cvalue) {
  localStorage.setItem(cotizadorKey, encodeURIComponent(cvalue));
}

function getCotizacion() {
  const data = localStorage.getItem(cotizadorKey);
  if (!data) return '';

  try {
    return decodeURIComponent(data);
  } catch (error) {
    return data;
  }
}

function updateCotizacion() {
  const localStorageData = getCotizacion();

  if (localStorageData) return true;

  setCotizacion('{"cotizador":[]}');
  return false;
}

function getCotizadorJson() {
  updateCotizacion();

  try {
    return JSON.parse(getCotizacion());
  } catch (error) {
    setCotizacion('{"cotizador":[]}');
    return { cotizador: [] };
  }
}

function saveCotizadorJson(data) {
  setCotizacion(JSON.stringify(data));
}

function uuidv4() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
  );
}

function formatMoney(cents) {
  const amount = Number(cents || 0) / 100;

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(amount);
}

function openDrawer() {
  if (!drawer) return;

  overlay?.classList.add('is-open');
  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
}

function closeDrawer() {
  if (!drawer) return;

  overlay?.classList.remove('is-open');
  drawer.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
}

function buildQuantityText(quantity, unit) {
  return `${quantity}${unit ? ` ${unit}` : ''}`;
}

function getItemTotal(item) {
  return Number(item.price || 0) * Number(item.quantity || 0);
}

function createRemoveButton(token) {
  const button = document.createElement('button');
  button.className = 'cotizador-drawer__remove';
  button.type = 'button';
  button.setAttribute('aria-label', translate('removeProduct'));
  button.dataset.label = translate('remove');
  button.dataset.cotizadorRemove = token;
  button.innerHTML = document.querySelector('[data-cotizador-close]')?.innerHTML || 'x';

  return button;
}

function createCotizadorItem(item) {
  const li = document.createElement('li');
  li.className = 'cotizador-drawer__item';

  const content = document.createElement('div');
  content.className = 'cotizador-drawer__item-content';

  const title = document.createElement('h4');
  title.className = 'cotizador-drawer__item-title';
  title.textContent = item.title || '';

  const price = document.createElement('p');
  price.className = 'cotizador-drawer__item-price';
  price.textContent = formatMoney(item.price);

  const quantity = document.createElement('p');
  quantity.className = 'cotizador-drawer__item-quantity';
  quantity.textContent = `${translate('quantity')}: ${buildQuantityText(item.quantity, item.unit)}`;

  content.append(title, price, quantity);
  li.append(createRemoveButton(item.token), content);

  if (item.image) {
    const image = document.createElement('img');
    image.className = 'cotizador-drawer__item-image';
    image.src = item.image;
    image.alt = '';
    li.append(image);
  }

  return li;
}

function updateHeaderCount(itemcount) {
  document.querySelectorAll('[data-cotizador-trigger]').forEach((trigger) => {
    const count = trigger.querySelector('[data-cotizador-count]');

    trigger.classList.toggle('has-items', itemcount > 0);
    if (count) count.textContent = itemcount > 0 ? itemcount : '';
  });
}

function getCotizadorItemCount() {
  const cotizadorJson = getCotizadorJson();

  return cotizadorJson.cotizador.reduce((total, item) => total + Number(item.quantity || 0), 0);
}

function syncHeaderCount() {
  updateHeaderCount(getCotizadorItemCount());
}

window.PortlandCotizadorSync = syncHeaderCount;

function updatePriceCart(show = false) {
  const cotizadorJson = getCotizadorJson();
  let sumaTotal = 0;
  let itemcount = 0;

  if (itemsList) itemsList.innerHTML = '';

  cotizadorJson.cotizador.forEach((item) => {
    const quantity = Number(item.quantity || 0);

    itemcount += quantity;
    sumaTotal += getItemTotal(item);
    itemsList?.append(createCotizadorItem(item));
  });

  if (subtotal) subtotal.textContent = formatMoney(sumaTotal);
  updateHeaderCount(itemcount);

  if (show) openDrawer();
}

function loadCotizacion() {
  const cotizadorJson = getCotizadorJson();
  let proMini = `${translate('quotedProducts')}\n\n`;

  cotizadorJson.cotizador.forEach((item) => {
    proMini += `${translate('product')}: ${item.title || ''}\n`;
    proMini += `${translate('sku')}: ${item.sku || translate('notAvailable')}\n`;
    proMini += `${translate('quantity')}: ${buildQuantityText(item.quantity, item.unit)}\n`;
    proMini += '\n';
  });

  if (messageInput) messageInput.value = proMini;
}

function getProductData(container) {
  const jsonScript = container?.querySelector('[data-cotizador-product-json]');
  if (!jsonScript) return null;

  try {
    return JSON.parse(jsonScript.textContent || '{}');
  } catch (error) {
    return null;
  }
}

function getSelectedVariant(productForm, productData) {
  const variantInput = productForm.querySelector('input[name="id"]');
  const variantId = variantInput?.value;

  return productData.variants?.find((variant) => String(variant.id) === String(variantId)) || productData.variants?.[0];
}

function getQuantity(productForm) {
  const quantityInput = productForm.querySelector('input[name="quantity"]');
  return Number(quantityInput?.value || 1);
}

function animateCotizadorButton(productForm) {
  const button = productForm.querySelector('[ref="addToCartButton"]');
  if (!button) return;

  button.dataset.added = 'true';

  setTimeout(() => {
    button.removeAttribute('data-added');
  }, 900);
}

function addCurrentProductToCotizador(productForm) {
  const productDataContainer = productForm.closest('[data-testid="product-information"]') || productForm;
  const productData = getProductData(productDataContainer);
  if (!productData) return;

  const variant = getSelectedVariant(productForm, productData);
  if (!variant) return;

  const quantity = getQuantity(productForm);
  const cotizadorJson = getCotizadorJson();
  const item = {
    token: uuidv4(),
    id: String(variant.id || ''),
    title: productData.title || '',
    extra: variant.title && variant.title !== 'Default Title' ? variant.title : '',
    sku: variant.sku || '',
    quantity: String(quantity),
    unit: productData.unit || '',
    price: String(variant.price || 0),
    image: variant.image || productData.image || '',
  };

  cotizadorJson.cotizador.push(item);
  saveCotizadorJson(cotizadorJson);
  animateCotizadorButton(productForm);
  updatePriceCart(true);
}

function setupMeasureUnits() {
  document.querySelectorAll('[data-testid="product-information"]').forEach((productInformation) => {
    const productData = getProductData(productInformation);
    const quantityWrapper = productInformation.querySelector('.quantity-selector-wrapper');

    if (!productData?.unit || !quantityWrapper) return;
    quantityWrapper.dataset.measureUnit = productData.unit;
  });
}

document.addEventListener(
  'click',
  (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const button = target?.closest('button[name="add"]');
    const productForm = button?.closest('product-form-component');
    if (!button || !productForm) return;
    if (button.classList.contains('quick-add__button--choose')) return;

    const productDataContainer = productForm.closest('[data-testid="product-information"]') || productForm;
    if (!productDataContainer.querySelector('[data-cotizador-product-json]')) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const form = productForm.querySelector('form');
    if (!form?.checkValidity()) {
      form?.reportValidity();
      return;
    }

    addCurrentProductToCotizador(productForm);
  },
  true
);

document.addEventListener(
  'submit',
  (event) => {
    const form = event.target instanceof HTMLFormElement ? event.target : null;
    const productForm = form?.closest('product-form-component');
    if (!form || !productForm) return;

    const productDataContainer = productForm.closest('[data-testid="product-information"]') || productForm;
    if (!productDataContainer.querySelector('[data-cotizador-product-json]')) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    addCurrentProductToCotizador(productForm);
  },
  true
);

document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;

  if (target?.closest('[data-cotizador-trigger]')) {
    event.preventDefault();
    updatePriceCart(true);
  }

  if (target?.closest('[data-cotizador-close]')) {
    event.preventDefault();
    closeDrawer();
  }

  if (target?.closest('[data-cotizador-overlay]')) {
    event.preventDefault();
    closeDrawer();
  }

  const remove = target?.closest('[data-cotizador-remove]');
  if (remove) {
    const token = remove.getAttribute('data-cotizador-remove');
    const cotizadorJson = getCotizadorJson();

    cotizadorJson.cotizador = cotizadorJson.cotizador.filter((item) => item.token !== token);
    saveCotizadorJson(cotizadorJson);
    updatePriceCart(false);
  }

  if (target?.closest('[data-cotizador-open-form]')) {
    event.preventDefault();
    closeDrawer();
    loadCotizacion();
    popup?.showModal();
    document.getElementById('CotizadorContactName')?.focus();
  }

  if (target?.closest('[data-cotizador-popup-close]')) {
    event.preventDefault();
    popup?.close();
  }

  if (target?.closest('[data-cotizador-clear]')) {
    event.preventDefault();
    saveCotizadorJson({ cotizador: [] });
    updatePriceCart(false);
  }
});

popup?.addEventListener('click', (event) => {
  if (event.target === popup) popup.close();
});

popupForm?.addEventListener('submit', (event) => {
  const form = event.currentTarget instanceof HTMLFormElement ? event.currentTarget : null;
  if (!form || form.dataset.cotizadorSubmitting === 'true') return;

  event.preventDefault();

  if (!form.checkValidity()) {
    form.reportValidity();
    return;
  }

  loadCotizacion();
  form.classList.add('is-submitting');
  form.dataset.cotizadorSubmitting = 'true';
  if (submitSuccess) submitSuccess.hidden = false;

  setTimeout(() => {
    form.submit();
  }, 3000);
});

if (cotizador?.querySelector('[data-cotizador-success]')) {
  saveCotizadorJson({ cotizador: [] });
}

setupMeasureUnits();
updatePriceCart(false);

let headerCountSyncQueued = false;
function queueHeaderCountSync() {
  if (headerCountSyncQueued) return;

  headerCountSyncQueued = true;
  requestAnimationFrame(() => {
    headerCountSyncQueued = false;
    syncHeaderCount();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', queueHeaderCountSync);
} else {
  queueHeaderCountSync();
}

window.addEventListener('pageshow', queueHeaderCountSync);
document.addEventListener('shopify:section:load', queueHeaderCountSync);
window.addEventListener('storage', (event) => {
  if (event.key === cotizadorKey) queueHeaderCountSync();
});

if (document.body) {
  new MutationObserver((mutations) => {
    const triggerWasAdded = mutations.some((mutation) =>
      [...mutation.addedNodes].some((node) => {
        if (!(node instanceof Element)) return false;

        return node.matches('[data-cotizador-trigger]') || Boolean(node.querySelector('[data-cotizador-trigger]'));
      })
    );

    if (triggerWasAdded) queueHeaderCountSync();
  }).observe(document.body, { childList: true, subtree: true });
}
